import React, { useEffect, useState } from "react";
import { useUser } from "../UserContext";
import { useNavigate } from "react-router-dom";
import { FaCertificate } from "react-icons/fa";
import axios from "axios";

const MyCertificate = () => {
  const { user } = useUser();
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCertificates = async () => {
      setLoading(true);
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';
        const { data } = await axios.get(
          `${apiUrl}/api/reports/approved`,
          { params: { username: user.username } }
        );
        setCertificates(data);
      } catch (err) {
        setCertificates([]);
      } finally {
        setLoading(false);
      }
    };
    if (user?.username) fetchCertificates();
  }, [user]);

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric'
    });

  return (
    <div className="max-w-4xl mx-auto mt-10">
      <div className="bg-white rounded-xl shadow-2xl border border-gray-200">
        <div className="bg-gradient-to-r from-indigo-500 to-blue-500 rounded-t-xl px-8 py-6 flex items-center gap-3">
          <FaCertificate className="text-3xl text-white" />
          <h2 className="text-2xl font-bold text-white tracking-wide">My Certificates</h2>
        </div>
        <div className="p-8">
          {loading ? (
            <div className="flex justify-center items-center py-12">
              <span className="text-lg text-gray-500 animate-pulse">Loading certificates...</span>
            </div>
          ) : certificates.length === 0 ? (
            <div className="flex flex-col items-center py-12">
              <FaCertificate className="text-5xl text-gray-300 mb-4" />
              <p className="text-lg text-gray-500">No certificates found.</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow">
                <thead>
                  <tr className="bg-gray-100 border-b">
                    <th className="px-4 py-3 border text-left text-sm font-semibold text-gray-700">S.No</th>
                    <th className="px-4 py-3 border text-left text-sm font-semibold text-gray-700">Course Name</th>
                    <th className="px-4 py-3 border text-left text-sm font-semibold text-gray-700">Date</th>
                    <th className="px-4 py-3 border text-center text-sm font-semibold text-gray-700">Certificate</th>
                  </tr>
                </thead>
                <tbody>
                  {certificates.map((cert, idx) => (
                    <tr
                      key={cert.id || idx}
                      className={
                        idx % 2 === 0
                          ? "bg-white hover:bg-blue-50 transition"
                          : "bg-gray-50 hover:bg-blue-50 transition"
                      }
                    >
                      <td className="px-4 py-3 border">{idx + 1}</td>
                      <td className="px-4 py-3 border">{cert.course_name || "-"}</td>
                      <td className="px-4 py-3 border">{formatDate(cert.reported_at)}</td>
                      <td className="px-4 py-3 border text-center">
                        <button
                          disabled={!cert.course_name}
                          onClick={() => {
                            const params = new URLSearchParams({
                              username: user.username,
                              courseName: cert.course_name,
                              workshopTitle: "Role of the Radiographer in Emergency Neuro imaging",
                              location: "Bhubaneswar",
                              date: formatDate(cert.reported_at),
                              certificateNo: cert.registration_id,
                              issueDate: formatDate(cert.updated_at || cert.reported_at),
                            });
                            navigate(`/student-dashboard/certificate?${params}`);
                          }}
                          className={`flex items-center justify-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 transition mx-auto shadow font-semibold text-sm ${
                            !cert.course_name ? 'opacity-50 cursor-not-allowed' : ''
                          }`}
                        >
                          <FaCertificate /> View Certificate
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyCertificate; 